import React, { useLayoutEffect, useEffect, useRef } from "react";
import { List, useDynamicRowHeight } from "react-window";
import { Card, Spin } from "antd";
import moment from "moment";
import _ from "lodash";

import "./index.scss";

const PAGE_SIZE = 50;

export default function TerminalLogViewer({ fetchLog, logs, loading, RowComponent, setLoading = () => {}, updateData = () => {} }) {
  const rowHeight = useDynamicRowHeight({
    defaultRowHeight: 50
  });
  const containerRef = useRef(null);
  const scrollAdjustRef = useRef(null);
  const allLogs = loading
    ? _.filter(logs, (log) => log.id !== "end")
    : logs;
  const wheelTimeout = useRef(null);

  useEffect(() => {
    fetchLog(1, PAGE_SIZE);
  }, []);

  useLayoutEffect(() => {
    // Restore scroll position immediately after DOM updates
    const container = containerRef.current;
    const info = scrollAdjustRef.current;
    const { scrollTop, scrollHeight, clientHeight } = container;
    const scrollBottom = scrollHeight + scrollTop - clientHeight;
    const isAtTop = Math.abs(scrollBottom) < Math.abs(scrollTop);

    if (info && container) {
      if(isAtTop){
        if(Math.abs(scrollBottom) < 200){
          container.scrollTop = info.scrollTop;
        }
      } else {
        if(Math.abs(scrollTop) < 200){
          container.scrollTop = info.scrollTop - (info.scrollHeight - scrollHeight) + 30;
        }
      }
      scrollAdjustRef.current = null; // reset
    }
    const dataLogs = _.filter(logs, (log) => log.id !== "end");
    if(dataLogs.length > (PAGE_SIZE * 2)){
      scrollAdjustRef.current = { scrollHeight: scrollHeight, scrollTop: container.scrollTop };
      let trimmedLogs = [];
      if(isAtTop){
        trimmedLogs = _.filter(logs, (log) => log.page > dataLogs[PAGE_SIZE * 2].page);
      } else { //at bottom
        trimmedLogs = _.filter(logs, (log) => log.page <= dataLogs[dataLogs.length - (PAGE_SIZE * 2)].page);
      }

      updateData(trimmedLogs);
    }
  }, [logs]);

  const handleWheel = (e) => {
    const el = containerRef.current;
    if (!el) return;
    const { scrollTop, scrollHeight, clientHeight } = el;
    const atBottom = scrollTop === 0;
    const scrollingDown = e.deltaY > 0;
    const scrollBottom = scrollHeight + scrollTop - clientHeight;

    if (atBottom && scrollingDown) {
      if (wheelTimeout.current) clearTimeout(wheelTimeout.current);
      setLoading(true);
      scrollAdjustRef.current = { scrollHeight, scrollTop };
      wheelTimeout.current = setTimeout(() => {
        fetchLog(_.max([1, (logs[logs.length - 1]?.page ?? 0) - 1]), PAGE_SIZE);
      }, 75);
    }

    if(scrollBottom === 0 && !scrollingDown && !loading) {
      if (wheelTimeout.current) clearTimeout(wheelTimeout.current);
      setLoading(true);
      scrollAdjustRef.current = { scrollHeight, scrollTop };
      wheelTimeout.current = setTimeout(() => {
        fetchLog((logs[0]?.page ?? 0) + 1, PAGE_SIZE);
      }, 75);
    }
  };

  return (
    <Card
      style={{
        width: "100%",
        height: 300,
        borderColor: "#D3D3D3",
        color: "#0f0",
        fontFamily: "monospace",
        display: "flex",
        flexDirection: "column-reverse",
        overflowY: "scroll"
      }}
      className="terminal-container"
      ref={containerRef}
      onWheel={handleWheel}
    >
      {loading && !_.isEqual(containerRef.current?.scrollHeight, containerRef.current?.clientHeight) && (
        <div style={{ textAlign: "center", marginTop: 8 }}>
          <Spin size="small" />
        </div>
      )}

      <List rowComponent={RowComponent} rowCount={allLogs.length} rowHeight={rowHeight} rowProps={{ logs: allLogs }} />

      {loading && (
        <div style={{ textAlign: "center", marginTop: 8 }}>
          <Spin size="small" />
        </div>
      )}
    </Card>
  );
}
